export default "__VITE_ASSET__eb66640e__"